import { RouterProvider } from 'react-router-dom';
import { router } from './utils/router';
import { ThemeProvider } from './components/theme-provider';
import { WalletProvider } from './components/providers/WalletProvider';
import { Toaster } from './components/ui/sonner';
import './styles/globals.css';

function App() {
  return (
    <WalletProvider>
      <ThemeProvider defaultTheme="dark">
        <RouterProvider router={router} />
        <Toaster position="top-right" />
      </ThemeProvider>
    </WalletProvider>
  );
}

export default App;